import styled from 'styled-components';
import { EllipsisV } from '@styled-icons/fa-solid/EllipsisV';

const AssociatedAssetParent = styled.div`
  .asset-block {
    padding: 8px 5px;
  }

  .asset-block: hover {
    background-color: #e7efff;
  }

  .asset-block: hover .asset-actions-toggle {
    visibility: visible;
  }

  .asset-actions-toggle {
    visibility: hidden;
  }

  .asset-name-block {
    font-size: 14px;
    color: #2b22ff;
    font-weight: bold;
    cursor: pointer;
  }
`;

const AssetActionsPopover = styled.div`
  box-shadow: 1px 2px 25px rgba(0, 0, 0, 0.152945);
  border-radius: 8px;

  .action-block {
    padding: 8px 16px;
    cursor: pointer;
  }

  .delete-action-name {
    font-size: 14px;
    color: #ea2632;
  }

  .action-block: hover {
    background-color: #e7efff;
  }
`;

export { AssociatedAssetParent, AssetActionsPopover };
